module.exports = __webpack_public_path__ + "ms.svg?ec75da93364b2dd68705a2718c551a8f";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/4x3/ms.svg
// module id = 1512
// module chunks = 0